import SettingsStore from 'stores/SettingsStore';

export function getCount(text: String) {
  const charactersSetting = SettingsStore.getSetting('messages', 'characters');
  const urlRegexp = charactersSetting ? new RegExp(charactersSetting.urlregexp, 'g') : null;

  let numberOfUrlsInMessage = 0;
  const textSansUrlsLength = text.replace(urlRegexp as RegExp, () => {
    numberOfUrlsInMessage++;
    return '';
  }).length;

  const urlWeight = charactersSetting ? charactersSetting.urlweight : 0;
  const urlsLength = urlWeight * numberOfUrlsInMessage;

  return textSansUrlsLength + urlsLength;
}

export function getRemainingCharacters(
  limit: number,
  limitWithFiles: number,
  length: number = 0,
  hasFiles: boolean = false
) {
  return (hasFiles ? limitWithFiles : limit) - length;
}

export function getRemainingCharactersForText(
  limit: number,
  limitWithFiles: number,
  text: string,
  hasFiles: boolean = false
) {
  return getRemainingCharacters(limit, limitWithFiles, getCount(text), hasFiles);
}

// require() compatibility and to support module spying
export default {
  getCount,
  getRemainingCharacters,
  getRemainingCharactersForText,
};
